@if (control()?.invalid() && (control()?.dirty() || control()?.touched() || submitted())) {
  <div class="ant-form-item-explain-error">
    @for (error of control()?.errors(); track error.kind) {
      <div>{{ error.message ?? messages[error.kind] }}</div>
    }
  </div>
}
<!-- <nz-list nzSize="small">
      @for (error of control()?.errors(); track error.kind) {
        <nz-list-item
          ><span class="ant-form-item-explain-error">{{
            error.message ?? messages[error.kind]
          }}</span></nz-list-item
        >
      }
    </nz-list> -->
